export const FIELD_SEPARATOR = '_';

export enum NodeType {
  HEAD = 'HEAD',
  PARAMETER = 'PARAMETER',
  PARAMETER_SET = 'PARAMETER_SET'
}

export enum Condition {
  AND = 'and',
  OR = 'or'
}

export interface Queriable {
  label: string;
  formName: string;
}

export interface QueryBuilderConfig {
  maxLevel: number;
  queriables: { [key: string]: Queriable};
  isConditionMandatory: boolean;
}

export interface EntityParameter {
  name: string;
  key: string;
}

export interface Node {
  type: NodeType;
}

export interface ConditionalNode extends Node {
  condition: Condition;
}

export interface QueryNode extends ConditionalNode {
  negate: boolean;
  rules: (any | QueryNode | Rule)[];
}

export interface Rule extends Node {
  fullName?: string;
  field: string;
  valueType: string;
  operator: string;
  value: any;
  key?: string
}

export interface ParameterRule extends ConditionalNode {
  parameter: string;
  rules: Rule[];
}
